export default function parseURL (url) {
  var a = document.createElement('a')
  a.href = url
  return {
    source: url,
    protocol: a.protocol.replace(':', ''),
    host: a.hostname,
    port: a.port,
    query: a.search,
    params: (function () {
      let ret = {},
        seg = a.search.replace(/^\?/, '').split('&'),
        len = seg.length, i = 0, s
      for (;i < len ; i++) {
        if (!seg[i]) { continue }
        s = seg[i].split('=')
        ret[s[0]] = s[1]
      }
      return ret
    })(),
    // eslint-disable-next-line no-useless-escape,no-sparse-arrays
    file: (a.pathname.match(/\/([^\/?#]+)$/i) || [, ''])[1],
    hash: a.hash.replace('#',''),
    // eslint-disable-next-line no-useless-escape
    path: a.pathname.replace(/^([^\/])/, '/$1'),
    // eslint-disable-next-line no-sparse-arrays,no-useless-escape
    relative: (a.href.match(/tps?:\/\/[^\/]+(.+)/) || [,''])[1],
    segments: a.pathname.replace(/^\//, '').split('/')
  }
}



// WEBPACK FOOTER //
// ./src/utils/parseURL.js